module.exports = __webpack_public_path__ + "img/inv.adf81aad.svg";